import { useMemo } from "react";
import { CreatorPanelTabs } from "../Tabs/CreatorPanelTabs";
import { EventType } from "@markit/common.types";

type EventDashboardTabsProps = {
  dashboardValue: number;
  setDashboardValue: (dashboardValue: number) => void;
  viewTextsTab: boolean;
  viewAnalyticsTab: boolean;
  viewFormsTab: boolean;
  viewPromosTab: boolean;
  viewSettingsTab: boolean;
  eventType: EventType;
};

export const EventDashboardTabs = (props: EventDashboardTabsProps) => {
  const {
    dashboardValue,
    setDashboardValue,
    viewTextsTab,
    viewAnalyticsTab,
    viewFormsTab,
    viewPromosTab,
    viewSettingsTab,
    eventType,
  } = props;

  const headerTabsNames = useMemo(() => {
    const tabNames = ["Dashboard"];
    if (eventType === EventType.EXTERNAL_EVENTBRITE) {
      return tabNames;
    }

    if (eventType === EventType.EXTERNAL_SHOWCLIX) {
      if (viewTextsTab) {
        tabNames.push("Texts");
      }
      return tabNames;
    }

    if (viewTextsTab) {
      tabNames.push("Texts");
    }
    if (viewAnalyticsTab) {
      tabNames.push("Analytics");
    }
    if (viewFormsTab) {
      tabNames.push("Collected Data");
    }
    if (viewPromosTab) {
      tabNames.push("Promos");
    }
    if (viewSettingsTab) {
      tabNames.push("Settings");
    }
    return tabNames;
  }, [
    eventType,
    viewAnalyticsTab,
    viewFormsTab,
    viewPromosTab,
    viewSettingsTab,
    viewTextsTab,
  ]);

  return (
    <div style={{ marginTop: 20, marginBottom: 30 }}>
      <CreatorPanelTabs
        tabValue={dashboardValue}
        setTabValue={setDashboardValue}
        tabNames={headerTabsNames}
      />
    </div>
  );
};
